import { RouterTabsTheme as RouterTabsDefaultTheme } from "@acin.reactjs/acin-ui/routerTabs";
import { applyIconColor } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";

const RouterTabsTheme = (theme: DefaultTheme): RouterTabsDefaultTheme => ({
  actionsComponent: {
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    marginRight: "16px",
  },

  actionsMenu: {
    marginRight: "16px",
  },

  tabsOptions: {
    groupTitle: {
      fontWeight: "600",
    },

    groupIcon: {
      display: "none",
      ...applyIconColor(theme.palette.primary[600]),
    },

    inputSearchIcon: {
      icon: applyIconColor(theme.palette.greys[600]),
    },

    root: {
      "&::before": {
        display: "none",
      },
    },

    active: {
      closeButton: {
        icon: applyIconColor(theme.palette.primary[700]),
      },
    },
  },

  expandButton: {
    active: {
      icon: applyIconColor(theme.palette.common.black),
    },
    root: {
      backgroundColor: theme.palette.common.white,
      padding: "0 8px",
    },
  },

  pinButton: {
    activeTab: {
      icon: applyIconColor(theme.palette.primary[700]),
    },
  },
});

export default RouterTabsTheme;
